import axios from "axios";
import { baseURL } from "../../Documentation/Reducers/thunks";

export const createCheckoutSession =
  ({ price_id }) =>
  async () => {
    try {
      return await axios({
        method: "post",
        url: baseURL + "billing/create-checkout-session",
        data: {
          price_id,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    } catch (e) {
      console.error(e);
      return e;
    }
  };
